// composables/useOffCanvas.js

export function useOffCanvas() {
    const visible = useState('offcanvas-visible', () => false);
    const content = useState('offcanvas-content', () => null);

    function show(opts) {
        content.value = {
            id: 'offcanvas-' + Math.random().toString(36).slice(2),
            title: opts.title || '',
            width: opts.width || 500,
            component: opts.component,
            props: opts.props || {}
        };

        visible.value = true;
    }

    function hide() {
        visible.value = false;
        content.value = null;
    }

    return { visible, content, show, hide };
}
